import React from 'react'
import styled from 'styled-components'
import { SelectFieldRegulationCP } from 'common/components/form/SelectFieldRegulationCP'
import { SelectSamplingsCP } from 'modules/samplings/components/select-samplings/SelectSamplingsCP'
import { DashboardFiltersFormModel } from 'app/screens/screen-home/inner/DashboardFiltersFormModel'
import { CardCP } from 'submodules/nerit-framework-ui/common/components/card/CardCP'
import { ButtonCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonCP'
import { TextCP } from 'submodules/nerit-framework-ui/common/components/text/TextCP'
import { TitleCP } from 'submodules/nerit-framework-ui/common/components/title/TitleCP'
import { RowCP } from 'submodules/nerit-framework-ui/common/components/grid/row/RowCP'
import { ColumnCP } from 'submodules/nerit-framework-ui/common/components/grid/column/ColumnCP'
import { DateRangePickerCP } from 'submodules/nerit-framework-ui/common/components/form-fields/date-range-picker/DateRangePickerCP'
import { IFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/types/IFormStateManager'
import { useEnterKeySearch } from 'submodules/nerit-framework-ui/common/responsiveness/use-enter-key-search/UseEnterKeySearch'

interface ICPProps {
    schemaName: string
    formStateManager: IFormStateManager<DashboardFiltersFormModel>
    onApply: () => void
    isLoading?: boolean
}

/**
 * Cabeçalho do Dashboard: identificação do empreendimento e filtro aplicado a todos os cards.
 */
export function DashboardFiltersHeaderCP(props: ICPProps): JSX.Element {

    useEnterKeySearch(props.onApply)

    return (
        <CardCP margin={'10px'}>
            <RowCP>
                <ColumnCP size={6} xs={24} md={24} lg={6}>
                    <TextCP text={'Empreendimento'} color={'#888'} size={'small'}/>
                    <TitleCP textSize={'large'} marginTop={4} marginBottom={0}>
                        {props.schemaName}
                    </TitleCP>
                </ColumnCP>
                <ColumnCP size={6} xs={24} md={8} lg={6}>
                    <SelectSamplingsCP
                        isRequired={true}
                        formStateManager={props.formStateManager}
                        fieldName={'samplingCode'}
                    />
                </ColumnCP>
                <ColumnCP size={5} xs={24} md={8} lg={5}>
                    <DateRangePickerCP
                        label={'Período'}
                        showBorder={true}
                        fastFilter={'all'}
                        fieldName={'dateRange'}
                        formStateManager={props.formStateManager}
                    />
                </ColumnCP>
                <ColumnCP size={5} xs={24} md={8} lg={5}>
                    <SelectFieldRegulationCP
                        isRequired={true}
                        formStateManager={props.formStateManager}
                        fieldName={'regulationCode'}
                        auxFieldNameSelectedOption={'regulationName'}
                    />
                </ColumnCP>
                <ColumnCP size={2} xs={24} md={24} lg={2}>
                    <ApplyButtonWrapperSCP>
                        <ButtonCP
                            type={'primary'}
                            icon={'search'}
                            onClick={props.onApply}
                            loading={props.isLoading}
                        >
                            Aplicar
                        </ButtonCP>
                    </ApplyButtonWrapperSCP>
                </ColumnCP>
            </RowCP>
        </CardCP>
    )
}

const ApplyButtonWrapperSCP = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 23px;
`
